import type { FC } from "react";
import Nav from "react-bootstrap/Nav";
import { useNavigate, useLocation } from "react-router-dom";

const AdminSubmenu: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = location.pathname.split("/")[2] || "orders";

  return (
    <Nav variant="tabs" activeKey={activeTab} className="mb-4">
      <Nav.Item>
        <Nav.Link eventKey="orders" onClick={() => navigate("/admin/orders")}>
          Orderhantering
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="exported-orders" onClick={() => navigate("/admin/exported-orders")}>
          Ej importerade ordrar
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="faq" onClick={() => navigate("/admin/faq")}>
          FAQ
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="settings" onClick={() => navigate("/admin/settings")}>
          Inställningar
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="syncStatus" onClick={() => navigate("/admin/sync-status")}>
          Synka status
        </Nav.Link>
      </Nav.Item>
    </Nav>
  );
};

export default AdminSubmenu;